<template>
  <div class="brush-dot elevation-2" :style="style"></div>
</template>

<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 5
    },
    color: {
      type: String,
      default: '#000000'
    }
  },

  computed: {
    style() {
      let sizeValue = typeof this.size === 'number' ? this.size + 'px' : this.size;
      return {
        width: sizeValue,
        height: sizeValue,
        backgroundColor: this.color
      };
    }
  },

  mounted() {
  }
};
</script>

<style lang="stylus" scoped>
.brush-dot {
  border-radius: 50%
  display: inline-block;
}

.brush-dot::after {
  content: " ";
}
</style>
